<template>
  <div class="content">
    <h1 class="account-message">You have zero credits</h1>
    <p class="message">
      Please top up your credits with the button below<br />
    </p>
    <router-link to="/my-account/manage-plan/top-up" class="btn"
      >View Packages</router-link
    >
  </div>
</template>

<style>
.content {
  gap: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.account-message,
.message {
  text-align: center;
}
</style>

<script>
import userMixin from "../../mixins/userMixin";

export default {
  name: "NoCredits",
  computed: {
    username: function () {
      return userMixin.methods.getUserName().toString();
    },
  },
};
</script>
